import styled from "@emotion/styled";
import { Container } from "@mui/system";

export const NftTokenPageContainer = styled(Container)`
  margin-top: 3.5rem;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
`;
